import { render, staticRenderFns } from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=template&id=30967e6b"
import script from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=style&index=0&id=30967e6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports